import { DataClassName } from '@/Data/const'

export const getTitleKey = (dataClassName: string) => {
  switch (dataClassName) {
    case DataClassName.ACTIVITY:
      return 'common.addItem.activity'
    case DataClassName.ADDRESS:
      return 'common.addItem.address'
    case DataClassName.COMPANY:
      return 'common.addItem.company'
    case DataClassName.CONTACT:
      return 'common.addItem.contact'
    case DataClassName.DOCUMENT:
      return 'common.addItem.document'
    case DataClassName.FOLLOW_UP:
      return 'common.addItem.followUp'
    case DataClassName.INVOICE:
      return 'common.addItem.invoice'
    case DataClassName.LEAD:
      return 'common.addItem.lead'
    case DataClassName.LIST:
      return 'common.addItem.list'
    case DataClassName.OPPORTUNITY:
      return 'common.addItem.opportunity'
    case DataClassName.ORDER:
      return 'common.addItem.order'
    case DataClassName.PERSON:
      return 'common.addItem.person'
    case DataClassName.QUOTE:
      return 'common.addItem.quote'
    case DataClassName.TICKET:
      return 'common.addItem.ticket'
    default:
      if (dataClassName.endsWith('Relation')) {
        return 'common.addItem.relation'
      }
      return ''
  }
}
